import { cn } from "@/utils/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-lg bg-gradient-subtle opacity-50 shimmer",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
